module.exports = __webpack_public_path__ + "static/media/scrollup.0f601347.svg";